import React, { useState, useEffect } from "react";
import Header from "../../../commons/Header/Header";
import Sidebar from "../../../commons/Sidebar/Sidebar";
import viewImage from "../../../assets/images/icons/view.svg";
import Star from "../../../assets/images/icons/star.svg";
import Profile from "../../../assets/images/profile.png";
import BlockIcon from "../../../assets/images/icons/block-icon.svg";
import FilterIcon from "../../../assets/images/icons/filter-icon.svg";
import Download from "../../../assets/images/icons/download-icon.svg";
import PDFIcon from "../../../assets/images/icons/pdf-icon.svg";
import Girl from "../../../assets/images/girl.jpg";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../../apis";
import { endpoints } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import Pagination from "react-bootstrap/Pagination";

import { Col, Row } from "react-bootstrap";

function ViewRestaurantRegistration() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [cms, setCms] = useState({ type: "publish" });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  const getList = async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        publish_status: cms?.type === "publish" ? 1 : 0,
        search,
        page,
        limit,
      }).toString();

      const response = await handleApiCall(
        "get",
        `${endpoints.teamList}?${query}`
      );
      if (response?.data?.code === 200) {
        setData(response?.data?.data?.team);
        setTotalPages(response?.data?.data?.totalPages || 1);
      } 
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, [cms, page, search]);

  const block = async (status, id) => {
    try {
      const response = await handleApiCall("put", endpoints.teamBlock, {
        status,
        teamId: id,
      });
      if (response?.data?.code === 200) {
        toast.success(response?.data?.data?.message || "Team status updated!");
        getList();
      }
    } catch (error) {
      toast.error("Failed to update team status.");
    }
  };

  const deleteTeam = async (id) => {
    if (window.confirm("Are you sure you want to delete this team?")) {
      try {
        const response = await handleApiCall(
          "delete",
          `${endpoints.teamDelete}?teamId=${id}`
        );
        if (response?.data?.code === 200) {
          toast.success("Team deleted successfully!");
          getList();
        } 
      } catch (error) {
        toast.error("Error deleting team.");
      }
    }
  };
  
  const totalRatings = 886;
  const averageRating = 4.8;

  // Simulated rating data
  const ratings = [
    { stars: 5, count: 7000 },
    { stars: 4, count: 200 },
    { stars: 3, count: 300 },
    { stars: 2, count: 20 },
    { stars: 1, count: 10 },
  ];

  // Max count for progress bar reference
  const maxCount = Math.max(...ratings.map(r => r.count));

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">View Restaurant Registration</h3>
            </div>
            <div>
              <Row>
                <Col md='3' className="mt-3">
                  <button className="btn btn-default rounded-lg">Back</button>
                </Col>
              </Row>

              <div className="profile-card pt-3 mt-n5">
                <img src={Profile} alt="Profile Picture" className="profile-img mb-3"/>
                <h4 className="fw-bold mb-0">Chuckles Jack</h4>
                <button className="btn btn-success mt-2 rounded-lg px-3 mr-2"><span className="mr-1">&#10003;</span> Approve</button>
                <button className="btn btn-danger mt-2 rounded-lg px-3"><span className="mr-1">&#x2715;</span> Reject</button>
              </div>
            </div>
            <div className="border rounded-14 py-2 px-3 mt-5">
              <div className="row mx-n2">
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Restaurant Id</strong>
                    <p className="mb-0 mt-2">#3242343</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Mobile Number</strong>
                    <p className="mb-0 mt-2">+44 999 9999 999</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Email id</strong>
                    <p className="mb-0 mt-2">Johndoe@Gmail.Com</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Address</strong>
                    <p className="mb-0 mt-2">ST Loyes House, 20 Loyes House Uk MK40 1ZL</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Cuisine Types</strong>
                    <p className="mb-0 mt-2">Fish and chips / Cornish pasty / Scotch egg</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>FSA Hygeine Number</strong>
                    <p className="mb-0 mt-2">#45623</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Delivery Coverage</strong>
                    <p className="mb-0 mt-2">5 Miles</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Pin Code</strong>
                    <p className="mb-0 mt-2">AB10</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Stripe ID</strong>
                    <p className="mb-0 mt-2">#45623</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>CRN Number</strong>
                    <p className="mb-0 mt-2">124568</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Current Subscription</strong>
                    <p className="mb-0 mt-2">Silver</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border p-3">
                    <strong>Payment</strong>
                    <p className="mb-0 mt-2">£100</p>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border d-flex align-items-center p-3">
                    <div className="flex-fill">
                      <strong>FSA Hygiene Number</strong>
                      <div className="small d-flex align-items-center mt-2"><img src={PDFIcon} alt="pdf" className="mr-2"/> FSA Hygiene Number.pdf</div>
                    </div>
                    <Link>
                      <img src={Download} alt="download"/>
                    </Link>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border d-flex align-items-center p-3">
                    <div className="flex-fill">
                      <strong>ID Proof</strong>
                      <div className="small d-flex align-items-center mt-2"><img src={PDFIcon} alt="pdf" className="mr-2"/> ID Proof.pdf</div>
                    </div>
                    <Link>
                      <img src={Download} alt="download"/>
                    </Link>
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="rounded-14 border d-flex align-items-center p-3">
                    <div className="flex-fill">
                      <strong>Proof Of Ownership</strong>
                      <div className="small d-flex align-items-center mt-2"><img src={PDFIcon} alt="pdf" className="mr-2"/> Ownership card.pdf</div>
                    </div>
                    <Link>
                      <img src={Download} alt="download"/>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewRestaurantRegistration;